import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../core/auth/auth.service';
import { TabService } from './tabs/tab.service';
import { Tab } from './tabs/tab.model';
import { JSetting } from '../interface/setting';
import { addDays, formatDistance } from 'date-fns';
import { AuthQuery } from '@ascschool/core/auth/auth.query';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {
  tabs = new Array<Tab>();
  @ViewChild('header', { static: false }) elementHeader: ElementRef;
  @ViewChild('sidebar', { static: false }) elementSidebar: ElementRef;
  @ViewChild('content', { static: false }) elementContent: ElementRef;
  @ViewChild('menuOption', { static: false }) elementMenuOption: ElementRef;
  isShowNavRight = true;
  maxHeight: number;
  heightContent: number;
  widthTabs: number;
  expanded: boolean;
  forceRender = false;
  settings: JSetting;
  dataBl = [
    {
      author: 'Anh Xanh',
      likes: 5,
      dislikes: 0,
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      content: 'Học, học nữa học mãi',
      datetime: formatDistance(new Date(), addDays(new Date(), 1))
    },
    {
      author: 'Anh Xanh',
      likes: 5,
      dislikes: 0,
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      content: 'Vững bước thành công',
      datetime: formatDistance(new Date(), addDays(new Date(), 2))
    }
  ];
  constructor(
    public _authService: AuthService,
    private cdRef: ChangeDetectorRef,
    public tabService: TabService,
    public authQuery: AuthQuery,
  ) {
    this.expanded = true;
  }

  ngOnInit(): void {
    this.tabService.tabSub.subscribe((tabs) => {
      this.tabs = tabs;
    });
    this.maxHeight = window.innerHeight;
    // this._authService.updateState();
      // this.settings = JSON.parse(localStorage.getItem('userSetting')).settings;
    this.authQuery.userSetting$.subscribe((res) => {
      this.settings = res;
      });
    this.handleResize();
    this._authService.getNavChangeEmitter().subscribe((item) => {
      setTimeout(() => {
        this.heightContent = this.caculateHeight();
        this.widthTabs = this.caculateWitdhTabs(this.settings?.positionMenuNav);
      }, 1);
    });
  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewInit() {
    setTimeout(() => {
      this.heightContent = this.caculateHeight();
      this.widthTabs = this.caculateWitdhTabs(this.settings?.positionMenuNav);
    }, 1);
    this.cdRef.detectChanges();
  }
  onResize() {
    this.heightContent = this.caculateHeight();
    this.widthTabs = this.caculateWitdhTabs(this.settings?.positionMenuNav);
  }
  caculateHeight(): number {
    this.maxHeight = window.innerHeight;
    const heightHeader: number = this.elementHeader.nativeElement.offsetHeight;
    // tslint:disable-next-line: max-line-length
    return this.maxHeight - heightHeader;
  }
  caculateWitdhTabs(typeSideBar: string): number {
    if (typeSideBar === 'top') {
      return window.innerWidth - this.elementSidebar.nativeElement.offsetWidth;
    } else if (typeSideBar === 'left') {
      return window.innerWidth - this.elementSidebar.nativeElement.offsetWidth;
    }
  }
  handleResize() {
    const match = window.matchMedia('(min-width: 1024px)');
    match.addEventListener('change', (e) => {
      this.expanded = e.matches;
    });
  }
  manualToggle() {
    this.expanded = !this.expanded;
    setTimeout(() => {
      this.widthTabs = this.caculateWitdhTabs(this.settings?.positionMenuNav);
    }, 250);
  }
  showNavBarRight() {
    this.isShowNavRight = !this.isShowNavRight;
  }
  // tslint:disable-next-line: member-ordering
  closeTab({ index }: { index: number }): void {
    this.tabService.closeTab({ index });
  }
  closeAllTab() {
    this.tabService.closeAllTab();
  }
  setSelectedIndex(event: any) {
    localStorage.setItem('selectedIndex', JSON.stringify(event.index));
  }
  checkForceRender() {
    this.forceRender = true;
  }
}
